"use strict";
var twentyninetimes = twentyninetimes || {};

twentyninetimes.languageSelector =
  twentyninetimes.languageSelector ||
  (function () {
    function init() {
        const languageSelector = document.querySelector(".language-action");

        if(languageSelector) {
            languageSelector.addEventListener("click", function() {
                const languageSelector = document.querySelector(".language-action");
                languageSelector.classList.toggle("active");
            });
        }
    }

    return {
      init: init,
    };
  })();